import { ClerkProvider } from '@clerk/clerk-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { queryClient } from '@shared/api';
import { config } from '@shared/config';
import { routeTree } from '../routeTree.gen';
import { ThemeProvider } from './theme-provider';

const CHUNK_RELOAD_KEY = 'chunk-reload';

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreloadStaleTime: 0,
  defaultOnCatch: (error) => {
    const isChunkError =
      error instanceof TypeError && error.message.includes('dynamically imported module');

    if (isChunkError && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
      window.location.reload();
    }
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * Root-App-Komponente mit allen Providern.
 * Wraps die Anwendung mit ClerkProvider, QueryClientProvider und RouterProvider.
 */
export const App = () => (
  <ClerkProvider publishableKey={config.clerkPublishableKey}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider />
      <RouterProvider router={router} />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </ClerkProvider>
);
